module.exports = __webpack_public_path__ + "img/spacebar.a7e1e53c.png";